
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(1(06|22|46)|22|545|577|889)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
